import React from "react";
import { motion } from "framer-motion";

function WhyChoose() {

  const collections = [
    {
      title: "Indian & Fruit Gelato",
      items: [
        "Mango",
        "Chikoo",
        "Jamun",        
        "Blueberry",
        "Strawberry",
      ],
    },

    {
      title: "The Nut Collection",
      items: [
        "Pistachio",
        "Hazelnut",
        "Cashew",
        "Almond",
        "Peanut Butter",
      ],
    },

    {
      title: "Chocolate & More",
      items: [
        "Biscoff",
        "Snickers",
        "Choco Hazelnut",        
        "Tiramisu",
        "Coffee",
      ],
    },
  ];

  const whyChoose = [
    {
      title: "Slow Churned",
      desc: "Churned slowly to incorporate less air for a smoother mouthfeel.",
    },

    {
      title: "Fresh Ingredients",
      desc: "We use real ingredients with no artificial preservatives or unnecessary additives.",
    },

    {
      title: "Naturally Lighter",
      desc: "Made with more milk and less cream, resulting in a cleaner finish.",
    },
  ];

  return (
    <motion.section
      className="festivo_section"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div className="container">

        {/* ================= HEADING ================= */}

        <motion.div
          className="text-center mission_header mb-5"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          viewport={{ once: true }}
        >

          <h2 className="journey_content">
            EXPLORE OUR SIGNATURE COLLECTION
          </h2>

          <div className="heading-underline"></div>

          <p className="section_subtitle">
            Crafted slowly. Served thoughtfully. Inspired by both
            global classics and local memories.
          </p>

        </motion.div>

        {/* ================= CATEGORY BOXES ================= */}

        <motion.div
          className="row gy-5 gx-4"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.25,
              },
            },
          }}
        >

          {collections.map((item, index) => (

            <div className="col-lg-4 col-md-6" key={index}>

              <motion.div
                className="glass_box h-100"
                variants={{
                  hidden: { opacity: 0, y: 60 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.7 }}
                whileHover={{ y: -10 }}
              >

                <h4>{item.title}</h4>

                <ul>
                  {item.items.map((list, i) => (
                    <li key={i}>{list}</li>
                  ))}
                </ul>

              </motion.div>

            </div>

          ))}

        </motion.div>

        {/* ================= WHY CHOOSE ================= */}

        <div className="mt-5 pt-lg-5">

          <motion.div
            className="text-center mission_header mb-5"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9 }}
            viewport={{ once: true }}
          >

            <h2 className="journey_content">
              WHY CHOOSE FESTIVO?
            </h2>

            <div className="heading-underline"></div>

          </motion.div>

          <div className="row gy-5 gx-4">

            {whyChoose.map((item, index) => (

              <div className="col-lg-4 col-md-6" key={index}>

                <motion.div
                  className="why_box h-100"
                  whileHover={{ y: -10 }}
                  transition={{ duration: 0.3 }}
                >

                  <h5>{item.title}</h5>

                  <p>{item.desc}</p>

                </motion.div>

              </div>

            ))}

          </div>

        </div>

      </div>
    </motion.section>
  );
}

export default WhyChoose;